// extracted by mini-css-extract-plugin
export default {"section":"BPM_section__y1x01","imgBx":"BPM_imgBx__i7tZ0","img":"BPM_img__T1wtd","content":"BPM_content__tnm68"};